import {CurrencyInput} from '../../CurrencyInput/CurrencyInput';
import {useFieldProps} from '../hooks/useFieldProps';
import {MoneyRendererResponseBody} from '../types/modelSchema';

const DEFAULT_DECIMAL_PLACES = 0;

export function MoneyRenderer(props: MoneyRendererResponseBody) {
  const {name, decimalPlaces, currency, tooltip} = props;
  const {onChange, onBlur, onFocus, value, isRequired, error} = useFieldProps(props);

  return (
    <CurrencyInput
      label={props.label}
      data-testid={name}
      onChange={onChange}
      onFocus={onFocus}
      isRequired={isRequired}
      errorMessage={error?.message}
      currency={currency}
      onBlur={onBlur}
      tooltip={tooltip}
      decimalPlaces={decimalPlaces ?? DEFAULT_DECIMAL_PLACES}
      value={value || ''}
      isDisabled={props.isReadOnly}
    />
  );
}
